module.exports = __webpack_public_path__ + "static/media/FUN88_Affiliate_Page_Icons_LINE.8a56fb84.svg";